export interface IStrokeScaleConfigOption {
  scaleId?: number
  scaleScoreId?: number
}

export interface IStrokeScaleScoreOption {
  [key: string]: unknown
  id?: number
  name?: string
  fieldValue?: string
}

export interface ICustomStrokeScaleAnswerOption extends IStrokeScaleScoreOption {
  question?: string
}

export interface ICustomStrokeScaleQuestionOption {
  question: string
  quesId: string
  answerOptions: ICustomStrokeScaleAnswerOption[]
}

export const getAllowedStrokeScoreIds = (
  strokeScaleId: number | undefined,
  strokeScaleConfigOptions: IStrokeScaleConfigOption[]
): Set<number> => {
  if (strokeScaleId == null) {
    return new Set()
  }

  return new Set(
    strokeScaleConfigOptions
      .filter((obj) => obj.scaleId === strokeScaleId)
      .map((obj) => obj.scaleScoreId)
      .filter((id): id is number => id != null)
  )
}

export const buildCustomStrokeScaleScoreOptions = (
  strokeScaleScoreOptions: IStrokeScaleScoreOption[],
  allowedScoreIds: Set<number>
): ICustomStrokeScaleQuestionOption[] =>
  strokeScaleScoreOptions
    .filter(
      (option): option is IStrokeScaleScoreOption & { id: number; name: string } =>
        option.id != null && option.name != null && allowedScoreIds.has(option.id)
    )
    .reduce<ICustomStrokeScaleQuestionOption[]>((customStructure, option) => {
      const question = option.name
      const quesId = question.toLowerCase().replace(/ /g, '_')
      const answerOption = { ...option, name: option.fieldValue }
      const alreadyHasQuestionIndex = customStructure.findIndex((customObj) => customObj.question === question)

      if (alreadyHasQuestionIndex >= 0) {
        customStructure[alreadyHasQuestionIndex].answerOptions.push(answerOption)
      } else {
        customStructure.push({
          question,
          quesId,
          answerOptions: [{ ...answerOption, question }],
        })
      }

      return customStructure
    }, [])
